import axios from "axios";

const adminAxios = axios.create({
  baseURL: "https://backpy.nbitez.com",
  headers: {
    "Content-Type": "application/json",
  },
});

// ===============================
// REQUEST INTERCEPTOR (ADMIN)
// ===============================
adminAxios.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem("adminToken");

   if (adminToken && adminToken !== "undefined" && adminToken !== "null") {
      config.headers.Authorization = `Bearer ${adminToken}`;
    } else if (adminToken === "undefined") {
       console.error("🛑 CRITICAL: adminToken is the STRING 'undefined'. Please logout and login again.");
    }

    // Diagnostic log
    console.log(`📡 ADMIN REQ: [${config.method?.toUpperCase()}] ${config.url}`, {
      fullToken: adminToken,
      headers: config.headers
    });

    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ===============================
// RESPONSE INTERCEPTOR (ADMIN)
// ===============================
adminAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("❌ ADMIN API ERROR:", {
      status: error.response?.status,
      data: error.response?.data,
      url: error.config?.url
    });

    if (error.response?.status === 401) {
      const isWalletRoute = error.config?.url?.includes("wallet");
      if (!isWalletRoute) {
        console.warn("🔒 401 Unauthorized detected. Redirecting to login...");
        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminRole");
        localStorage.removeItem("adminName");
        window.location.href = "/admin/login";
      } else {
        console.warn("🔒 401 Unauthorized on Wallet route - skipping redirect.");
      }
    }

    if (error.response?.status === 403) {
      console.warn("🚫 403 Forbidden - Permission denied.");
    }

    return Promise.reject(error);
  }
);

export default adminAxios;
